// extracted by mini-css-extract-plugin
export var noteCell = "b6edc3395a7f819785fd45ba0209e214-css";
export var noteCellText = "d6ef20c207486a8d2078bae8961f0b40-css";